import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import grid from './Grid.module.scss';

const stringOrNumber = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
]);
const numberOrObject = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.object,
]);

function Col({
  span,
  offset = 0,
  className = '',
  justify,
  align,
  children,
  flex = false,
  prefix = 'datalab-grid-col',
  order,
  ...others
}) {
  let sizeClasses = {};
  ['xss', 'xs', 'sm', 'md', 'lg', 'xl'].forEach((size) => {
    if (others[size]) {
      let sizeParams = {};
      if (typeof others[size] === 'number') {
        sizeParams.span = others[size];
      } else if (typeof others[size] === 'object') {
        sizeParams = others[size] || {};
      }
      sizeClasses = {
        ...sizeClasses,
        [grid[`${prefix}-${size}-${sizeParams.span}`]]:
          typeof sizeParams.span !== 'undefined',
        [grid[`${prefix}-${size}-offset-${sizeParams.offset}`]]:
          sizeParams.offset || sizeParams.offset === 0,
        [grid[`${prefix}-${size}-order-${sizeParams.order}`]]:
          sizeParams.order || sizeParams.order === 0,
      };
    }
  });
  const classes = cx(
    {
      [grid[`${prefix}-${span}`]]: span !== undefined,
      [grid[`${prefix}-offset-${offset}`]]: offset,
      [grid[`${prefix}-order-${order}`]]: order,
      [grid[`${prefix}-flex`]]: flex,
      [grid[`${prefix}-${justify}`]]: justify,
      [grid[`${prefix}-${align}`]]: align,
    },
    className,
    sizeClasses,
  );

  return (
    <div {...others} className={classes}>
      {children}
    </div>
  );
}

Col.propTypes = {
  align: PropTypes.oneOf(['top', 'bottom', 'middle', 'stretch']),
  justify: PropTypes.oneOf([
    'start',
    'center',
    'end',
    'space-between',
    'space-around',
  ]),
  className: PropTypes.string,
  children: PropTypes.node,
  flex: PropTypes.bool,
  span: stringOrNumber,
  xs: numberOrObject,
  sm: numberOrObject,
  md: numberOrObject,
  lg: numberOrObject,
  xl: numberOrObject,
  offset: stringOrNumber,
  prefix: PropTypes.string,
  order: stringOrNumber,
};

export default Col;
